import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  complete(event) {
    // Verhindere das normale Link-Verhalten
    event.preventDefault()
    
    const button = event.currentTarget
    const originalContent = button.innerHTML
    
    // Zeige Loading-Animation
    button.innerHTML = `
      <div class="flex items-center justify-center gap-2">
        <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
        <span class="hidden sm:inline">Wird abgeschlossen...</span>
        <span class="sm:hidden">...</span>
      </div>
    `
    
    // Deaktiviere den Button
    button.disabled = true
    button.classList.add('opacity-75', 'cursor-not-allowed')
    
    // Führe die AJAX-Anfrage aus
    fetch(button.href, {
      method: 'PUT',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Accept': 'text/vnd.turbo-stream.html',
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      if (response.ok) {
        // Erfolgreich abgeschlossen - zeige Erfolgsanimation
        this.showSuccessAnimation(button)
        
        // Nach 2 Sekunden die Zeile entfernen oder aktualisieren
        setTimeout(() => {
          const row = button.closest('tr')
          if (row) {
            // Füge eine schöne Ausblend-Animation hinzu
            row.style.transition = 'all 0.5s ease-out'
            row.style.opacity = '0'
            row.style.transform = 'translateX(-100%)'
            
            setTimeout(() => {
              row.remove()
            }, 500)
          }
        }, 2000)
      } else {
        // Fehler beim Abschließen
        this.showErrorAnimation(button, originalContent)
      }
    })
    .catch(error => {
      this.showErrorAnimation(button, originalContent)
    })
  }
  
  showSuccessAnimation(button) {
    // Ändere den Button zu einem Erfolgs-Status
    button.innerHTML = `
      <div class="flex items-center justify-center gap-2">
        <i class="fas fa-check-circle text-green-500 animate-bounce"></i>
        <span class="hidden sm:inline text-green-600 font-semibold">Abgeschlossen!</span>
        <span class="sm:hidden text-green-600 font-semibold">✓</span>
      </div>
    `
    
    // Ändere die Button-Farben
    button.classList.remove('bg-green-600', 'hover:bg-green-700')
    button.classList.add('bg-green-100', 'text-green-800', 'border', 'border-green-300')
    
    // Füge einen pulsierenden Effekt hinzu
    button.classList.add('animate-pulse')
    
    // Zeige eine kleine Erfolgs-Notification
    this.showNotification('Todo erfolgreich abgeschlossen!', 'success')
  }
  
  showErrorAnimation(button, originalContent) {
    // Zeige Fehler-Animation
    button.innerHTML = `
      <div class="flex items-center justify-center gap-2">
        <i class="fas fa-exclamation-triangle text-red-500"></i>
        <span class="hidden sm:inline text-red-600">Fehler!</span>
        <span class="sm:hidden">!</span>
      </div>
    `
    
    // Ändere die Button-Farben zu Fehler-Farben
    button.classList.remove('bg-green-600', 'hover:bg-green-700')
    button.classList.add('bg-red-100', 'text-red-800', 'border', 'border-red-300')
    
    // Nach 3 Sekunden zur ursprünglichen Form zurückkehren
    setTimeout(() => {
      button.innerHTML = originalContent
      button.disabled = false
      button.classList.remove('opacity-75', 'cursor-not-allowed', 'bg-red-100', 'text-red-800', 'border', 'border-red-300')
      button.classList.add('bg-green-600', 'hover:bg-green-700')
    }, 3000)
    
    this.showNotification('Fehler beim Abschließen des Todos', 'error')
  }
  
  showNotification(message, type) {
    // Erstelle eine einfache Notification
    const notification = document.createElement('div')
    notification.className = `fixed top-4 right-4 z-50 px-4 py-2 rounded-md text-white font-medium shadow-lg transform transition-all duration-300 ${
      type === 'success' ? 'bg-green-500' : 'bg-red-500'
    }`
    notification.textContent = message
    
    document.body.appendChild(notification)
    
    // Zeige die Notification
    setTimeout(() => {
      notification.classList.add('translate-x-0', 'opacity-100')
    }, 100)
    
    // Entferne die Notification nach 3 Sekunden
    setTimeout(() => {
      notification.classList.add('translate-x-full', 'opacity-0')
      setTimeout(() => {
        document.body.removeChild(notification)
      }, 300)
    }, 3000)
  }
}
